import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IUpdateSiteAvailabilityParams {
  ids: string[]; // row ids, not urlNames
  availability: string;
}

export interface IUpdateSiteAvailabilityResult extends IResult {
}

export class UpdateSiteAvailabilityRequest extends Request<IUpdateSiteAvailabilityParams, IUpdateSiteAvailabilityResult> {
  constructor(params: IUpdateSiteAvailabilityParams) {
    super('updateSiteAvailability', params);
  }
}
